export const setNotes = 'Successfully changed notes!';
export const editNotesTitle = 'Edit notes';
export const editText = 'edit';
export const saveNotesButton = 'save notes';
export const editNotesPlaceholder = 'Add service request notes here...';
export const requestNotesTitle = 'Request notes';
